import { useState } from "react"
import { useFileDownload } from "./useFileDownload"

type SelectedFile = {
  file: any
  uniqueId: string
}

export const useFileSelection = () => {
  const [selectedFiles, setSelectedFiles] = useState<SelectedFile[]>([])

  const { downloadProgress, downloadAsZip, resetProgress } = useFileDownload()

  const createUniqueFileId = (fileType: string, index: number) => {
    return `${fileType}_${index}`
  }

  const handleFileSelection = (file: any, uniqueId: string, isChecked: boolean) => {
    setSelectedFiles((prev) => {
      if (isChecked) {
        const isAlreadySelected = prev.some((item) => item.uniqueId === uniqueId)
        if (!isAlreadySelected) {
          return [...prev, { file, uniqueId }]
        }
        return prev
      } else {
        return prev.filter((item) => item.uniqueId !== uniqueId)
      }
    })
  }

  const isFileSelected = (uniqueId: string) => {
    return selectedFiles.some((item) => item.uniqueId === uniqueId)
  }

  const getSelectedFiles = () => {
    return selectedFiles.map((item) => item.file)
  }

  const clearSelection = () => {
    setSelectedFiles([])
  }

  const getAllDownload = async (allFiles: any) => {
    await downloadAsZip(allFiles)
  }

  return {
    selectedFiles,
    selectedCount: selectedFiles.length,
    createUniqueFileId,
    handleFileSelection,
    isFileSelected,
    getSelectedFiles,
    clearSelection,
    getAllDownload,
    resetProgress,
    downloadProgress,
  }
}
